<template>
    <div>
        <v-textarea
            label="Canais"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.phone"
        >
        </v-textarea>
        <v-textarea
            label="Endereço"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.address"
        >
        </v-textarea>
        <v-text-field
            label="Link - Como chegar"
            v-model="ctn.items.link"
            :disabled="!enabled"
        ></v-text-field>
        <v-textarea
            label="Emails - Assessoria de Imprensa"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.pressEmails"
        ></v-textarea>
        <v-textarea
            label="Pessoas - Assessoria de Imprensa"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.pressPeople"
        ></v-textarea>
        <v-textarea
            label="Telefone - Assessoria de Imprensa"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.pressPhone"
        ></v-textarea>
        <v-textarea
            label="Link - Assessoria de Imprensa"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.pressLink"
        ></v-textarea>
        <v-textarea
            label="Texto - Assessoria de Imprensa"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.pressText"
        ></v-textarea>
    </div>
</template>

<script>
export default {
    props: ["disabled"],
    data: function() {
        return {
            ctn: {
                items: {
                    phone: "",
                    address: "",
                    link: "",
                    pressEmails: "",
                    pressPeople: "",
                    pressPhone: "",
                    pressLink: "",
                    pressText: ""
                }
            },
            enabled: true
        };
    },
    created: function() {
        if (this.$props.disabled === true) this.enabled = false;
        if (this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
    },
    methods: {
        getModuleData() {
            return this.ctn.items;
        }
    }
};
</script>
